module.exports = __webpack_public_path__ + "img/1.6d000dd6.jpg";